import React from "react";
import { Box, Container, Typography, Button, Grid } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { ArrowForward, Phone, Email } from "@mui/icons-material";

const CTASection = ({
  title = "Ready to Transform Your Communication Infrastructure?",
  description = "Get in touch with our team to discuss how ProtoDiag Solutions can help your business.",
  primaryButtonText = "Contact Us",
  primaryButtonLink = "/contact",
  secondaryButtonText = "View Solutions",
  secondaryButtonLink = "/products",
  variant = "primary", // primary or secondary
}) => {
  return (
    <Box
      sx={{
        py: { xs: 6, md: 10 },
        backgroundColor:
          variant === "primary" ? "primary.main" : "background.paper",
        color: variant === "primary" ? "primary.contrastText" : "text.primary",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Background pattern */}
      {variant === "primary" && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            opacity: 0.1,
            backgroundImage:
              "radial-gradient(circle, #ffffff 1px, transparent 1px)",
            backgroundSize: "20px 20px",
          }}
        />
      )}

      <Container maxWidth="lg">
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={8}>
            <Typography
              variant="h2"
              component="h2"
              sx={{
                fontWeight: 700,
                mb: 2,
                fontSize: { xs: "2rem", md: "2.5rem" },
              }}
            >
              {title}
            </Typography>
            <Typography
              variant="h6"
              sx={{
                mb: 4,
                opacity: variant === "primary" ? 0.9 : 0.8,
                fontWeight: 400,
              }}
            >
              {description}
            </Typography>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
              <Button
                variant="contained"
                color={variant === "primary" ? "secondary" : "primary"}
                size="large"
                component={RouterLink}
                to={primaryButtonLink}
                endIcon={<ArrowForward />}
                sx={{
                  px: 4,
                  py: 1.5,
                  fontSize: "1rem",
                  fontWeight: 600,
                }}
              >
                {primaryButtonText}
              </Button>
              <Button
                variant={variant === "primary" ? "outlined" : "contained"}
                color={variant === "primary" ? "inherit" : "secondary"}
                size="large"
                component={RouterLink}
                to={secondaryButtonLink}
                sx={{
                  px: 4,
                  py: 1.5,
                  fontSize: "1rem",
                  fontWeight: 600,
                  borderColor: variant === "primary" ? "white" : undefined,
                  "&:hover": {
                    borderColor: variant === "primary" ? "white" : undefined,
                    backgroundColor:
                      variant === "primary"
                        ? "rgba(255,255,255,0.1)"
                        : undefined,
                  },
                }}
              >
                {secondaryButtonText}
              </Button>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  p: 2,
                  borderRadius: 2,
                  backgroundColor:
                    variant === "primary"
                      ? "rgba(255,255,255,0.1)"
                      : "rgba(0,0,0,0.05)",
                }}
              >
                <Phone sx={{ fontSize: 32 }} />
                <Box>
                  <Typography variant="subtitle2" fontWeight={600}>
                    Call Us
                  </Typography>
                  <Typography variant="body2">+91-9899817807</Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  p: 2,
                  borderRadius: 2,
                  backgroundColor:
                    variant === "primary"
                      ? "rgba(255,255,255,0.1)"
                      : "rgba(0,0,0,0.05)",
                }}
              >
                <Email sx={{ fontSize: 32 }} />
                <Box>
                  <Typography variant="subtitle2" fontWeight={600}>
                    Email Us
                  </Typography>
                  <Typography variant="body2">info@protodiag.com</Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default CTASection;
